import { FormControl, Autocomplete, Grid, TextField } from "@mui/material";

export function ExecutiveChefEmailSelect({
  handleSelect,
  executiveChefList,
  errors,
}) {
  return (
    <FormControl required fullWidth>
      <Autocomplete
        id="grouped-executive-chef-email-select-sample-request-details-autocomplete"
        onChange={(e, newValue) =>
          handleSelect("executiveChefEmailSelect", newValue.email)
        }
        loading={true}
        options={executiveChefList}
        groupBy={(option) => option.department}
        getOptionLabel={(option) => `${option.name} (${option.email})`}
        fullWidth
        renderOption={(props, option) => (
          <Grid {...props} container ml={3} mb={2}>
            <Grid item xs={12}>
              {option.name}
            </Grid>
            <Grid item xs={12}>
              <small>{option.email}</small>
            </Grid>
          </Grid>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label="Executive Chef Email"
            error={errors && errors.executiveChefEmail && true}
            helperText={
              errors && errors.executiveChefEmail !== ""
                ? errors.executiveChefEmail
                : ""
            }
          />
        )}
      />
    </FormControl>
  );
}
